import { render, staticRenderFns } from "./form_doc_vencer_empresas.vue?vue&type=template&id=32fc083b&"
import script from "./form_doc_vencer_empresas.vue?vue&type=script&lang=js&"
export * from "./form_doc_vencer_empresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32fc083b')) {
      api.createRecord('32fc083b', component.options)
    } else {
      api.reload('32fc083b', component.options)
    }
    module.hot.accept("./form_doc_vencer_empresas.vue?vue&type=template&id=32fc083b&", function () {
      api.rerender('32fc083b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/relatorios_gn/form_doc_vencer_empresas.vue"
export default component.exports